import { render, staticRenderFns } from "./SoundAppointment.vue?vue&type=template&id=5a61b07f"
import script from "./SoundAppointment.vue?vue&type=script&lang=js"
export * from "./SoundAppointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports